// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__anPN7","validationTips":"StatementDescriptor_validationTips__7YbZQ"};